import {
  Directive,
  ElementRef,
  inject,
  Input,
  OnInit
} from '@angular/core';

import { SettingsState } from '@core/settings';
import { environment } from '@env';

import { INTERNAL_CURRENCY_CODE } from './constants';
import { CurrenciesState } from './currencies.state';

@Directive({
  selector: '[currencyClassname]'
})
export class CurrencyClassnameDirective implements OnInit {
  private readonly elementRef = inject(ElementRef);
  private readonly currenciesState = inject(CurrenciesState);
  private readonly settingsState = inject(SettingsState);

  @Input()
  public convertClassName = 'currency';

  get currencyCode(): string {
    const isStreamerMode = this.settingsState.streamerMode();
    const userCurrency = this.currenciesState.userCurrency();

    if(isStreamerMode && userCurrency === environment.baseCurrency) {
      return INTERNAL_CURRENCY_CODE;
    }

    return this.currenciesState.userCurrency();
  }

  ngOnInit(): void {
    const { nativeElement } = this.elementRef;
    const className = `${ this.convertClassName }_${ this.currencyCode }`;

    nativeElement.classList.add(className);
  }
}
